import CescoApply from "../../../../src/events/2022/06/cescoApply/main";
import * as React from 'react';
export default {
  CescoApply,
  React
};